import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="min-h-screen bg-slate-50 flex items-center justify-center px-4 py-16">
      <div className="max-w-lg w-full bg-white border border-slate-200 rounded-3xl p-10 text-center shadow-xl">
        <XCircle className="w-16 h-16 text-amber-500 mx-auto" />
        <h1 className="font-display uppercase text-3xl mt-4 text-slate-900">Payment cancelled</h1>
        <p className="text-slate-500 mt-3">No problem — your booking has been saved as pending. You can pay later or choose to pay at the session.</p>
        <div className="mt-8 flex gap-3 justify-center">
          <Link to="/" className="btn-gold">Back to home</Link>
          <Link to="/private-sessions" className="btn-outline-blue">Try Again</Link>
        </div>
      </div>
    </div>
  );
}
